import { init } from './analyticsInit';
import { init as initUserActionEvents } from './userActionEvents';

init();
initUserActionEvents();
